import type { Styles } from "react-modal";
import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import type { CSSSize } from "app/UtilitiesAndConstants/types/cssTypes";

export const SECTION_GAP_X: CSSSize = "12px";

export const CUSTOM_MODAL_STYLES: Styles = {
    content: {
        width: 1032,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        boxSizing: "border-box",
    },
};

export const StyledContentWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${SECTION_GAP_X};
`;

export const ColumnsContainer = styled(Stack)`
    height: 400px;

    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 4px;
`;

export const ColumnsContainerHeader = styled.div`
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    box-sizing: border-box;
    height: 56px;
`;

export const StyledSelectedColumnsHeader = styled(ColumnsContainerHeader)`
    padding: 16px 16px;
`;

export const CancelButton = styled(Button)`
    margin-right: 4px;
`;
